import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SyncLogTable } from './sync-log-table';
import { HubspotCompaniesTable } from './hubspot-companies-table';
import { HubspotContactsTable } from './hubspot-contacts-table';
import { HubspotDealsTable } from './hubspot-deals-table';
import type { IntegrationConfig, SyncLog } from '../types/integration.types';

interface Props {
  config: IntegrationConfig;
  logs: SyncLog[];
}

export function HubspotDataView({ config, logs }: Props) {
  return (
    <Tabs defaultValue="companies" className="w-full">
      <TabsList>
        <TabsTrigger value="companies">Empresas</TabsTrigger>
        <TabsTrigger value="contacts">Contactos</TabsTrigger>
        <TabsTrigger value="deals">Negocios</TabsTrigger>
        <TabsTrigger value="logs">Historial</TabsTrigger>
      </TabsList>
      <TabsContent value="companies" className="pt-4">
        <HubspotCompaniesTable integrationId={config.id} />
      </TabsContent>
      <TabsContent value="contacts" className="pt-4">
        <HubspotContactsTable integrationId={config.id} />
      </TabsContent>
      <TabsContent value="deals" className="pt-4">
        <HubspotDealsTable integrationId={config.id} />
      </TabsContent>
      <TabsContent value="logs" className="pt-4">
        <SyncLogTable logs={logs} showIntegration={false} />
      </TabsContent>
    </Tabs>
  );
}
